import { LitElement } from "lit";

/**
 * PageElement is the base for routed pages. It centralizes the accessibility
 * contract (R7): on first render it moves focus to the page's <h1> (made
 * programmatically focusable) and pages set the document title via setTitle so a
 * route change both moves focus and updates document.title.
 */
export class PageElement extends LitElement {
  protected setTitle(title: string): void {
    document.title = title ? `${title} · bino Registry` : "bino Registry";
  }

  /** focusHeading moves keyboard focus to the page heading. Idempotent. */
  protected focusHeading(): void {
    const h = this.renderRoot?.querySelector("h1");
    if (h) {
      h.setAttribute("tabindex", "-1");
      (h as HTMLElement).focus();
    }
  }

  override firstUpdated(): void {
    this.focusHeading();
  }
}
